<template>
  <section class="mh-experince image-bg featured-img-one" id="my-experience">
    <div class="img-color-overlay">
      <div class="container">
        <div class="row section-separator">
          <div class="col-sm-12 col-md-12">
            <div class="mh-work">
              <h3>Work Experience</h3>
              <div class="mh-experience-deatils">
                <div class="row">
                  <div
                    class="col-md-6 col-sm-12 experience-card"
                    v-for="(item, index) in experiences"
                    :key="index"
                  >
                    <div
                      class="mh-work-item dark-bg wow fadeInUp"
                      data-wow-duration="0.8s"
                      data-wow-delay="0.4s"
                    >
                      <h4>
                        {{item.job_title}},
                        <a :href="item.employerURL" v-text="item.employer" v-show="item.employer"></a>
                      </h4>
                      <div class="work-duration" v-show="item.start">
                        <span class="mh-eduyear start-date" v-text="item.start"></span>
                        <span class="start-date">--</span>
                        <span class="mh-eduyear end-date" v-text="item.end"></span>
                      </div>
                      <p v-text="item.description" v-show="item.description"></p>
                      <span class="subhead" v-show="!item.description && item.bullets && item.bullets.length > 0">Responsibilities:</span>
                      <ul
                        class="work-responsibility"
                        :style="calcIndent(item.description)"
                        v-show="item.bullets && item.bullets.length > 0"
                      >
                        <li v-for="(item, index) in item.bullets" :key="'bullet-'+index">
                          <i class="fa fa-circle"></i>
                          {{item}}
                        </li>
                      </ul>

                      <span class="subhead" v-show="item.technologies">Technologies: </span>
                      <p class="technologies" v-show="item.technologies" v-text="joinTechnologies(item.technologies)"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    experiences() {
      return this.$store.state.exp;
    }
  },

  methods: {
    calcIndent(hasText) {
      return hasText ? "margin-left: 25px" : "";
    },
    joinTechnologies(techs){
      return techs && techs.length > 0 ? techs.join(", ") : null;
    }
  }
};
</script>

<style scoped>
.work-duration {
  padding-bottom: 8px;
}
.start-date {
  padding-right: 10px;
  font-size: 14px !important;
}
.end-date {
  padding-right: 10px;
  font-size: 14px !important;
}

.experience-card {
  padding-bottom: 2% !important;
}

.subhead{
  font-size: 14px !important;
  color: #58978c !important;
  font-weight: 700 !important;
  margin-top: 1% !important;
}

.technologies{
  word-break: break-word !important;
}

/* For Small devices and Tablets */
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .experience-card {
    padding-top: 1% !important;
  }
}
</style>
